import data from '@emoji-mart/data/sets/15/native.json';
import { t } from '@lumen/platform';

interface RawEmoji {
  id: string;
  name: string;
  keywords: string[];
  skins: { native: string }[];
}

interface RawData {
  categories: { id: string; emojis: string[] }[];
  emojis: Record<string, RawEmoji>;
}

export interface Emoji {
  id: string;
  name: string;
  keywords: string[];
  native: string;
  /** Skin tone variants (index 0 = default). */
  skins: string[];
}

const raw = data as unknown as RawData;

export const EMOJI_CATEGORIES: { id: string; label: string; emojis: Emoji[] }[] = raw.categories.map((c) => ({
  id: c.id,
  label:
    { people: t('People'), nature: 'Animals & Nature', foods: 'Food & Drink', activity: t('Activity'), places: 'Travel & Places', objects: t('Objects'), symbols: t('Symbols'), flags: t('Flags') }[c.id] ?? c.id,
  emojis: c.emojis.map((id) => toEmoji(raw.emojis[id]!)).filter(Boolean),
}));

function toEmoji(e: RawEmoji): Emoji {
  return { id: e.id, name: e.name, keywords: e.keywords, native: e.skins[0]!.native, skins: e.skins.map((s) => s.native) };
}

export const ALL_EMOJI: Emoji[] = EMOJI_CATEGORIES.flatMap((c) => c.emojis);

export function searchEmoji(query: string, limit = 200): Emoji[] {
  const q = query.trim().toLowerCase().replace(/^:/, '');
  if (!q) return ALL_EMOJI.slice(0, limit);
  const scored: [number, Emoji][] = [];
  for (const e of ALL_EMOJI) {
    let score = -1;
    if (e.id === q || e.name.toLowerCase() === q) score = 0;
    else if (e.id.startsWith(q) || e.name.toLowerCase().startsWith(q)) score = 1;
    else if (e.keywords.some((k) => k.startsWith(q))) score = 2;
    else if (e.id.includes(q) || e.name.toLowerCase().includes(q)) score = 3;
    if (score >= 0) scored.push([score, e]);
  }
  return scored.sort((a, b) => a[0] - b[0]).slice(0, limit).map(([, e]) => e);
}

/** Emoji that make good default page icons (used by "Add icon"). */
const RANDOM_POOL = ['📄', '📝', '📚', '🚀', '💡', '🎯', '🌱', '🔥', '⭐', '🧠', '📌', '🗂️', '🎨', '🧩', '🌈', '☕', '🏔️', '🌊', '🍀', '🪴'];
export function randomEmoji(): string {
  return RANDOM_POOL[Math.floor(Math.random() * RANDOM_POOL.length)]!;
}

export function withSkin(e: Emoji, skin: number): string {
  return e.skins[skin] ?? e.native;
}
